import { lazy } from 'react'

const Content = lazy(() => import('./content.component'))

export { Content }
